import { Box, Link } from '@mui/material'
import { FoxModalDialog } from '../../../components/common/FoxModalDialog'
import { FoxTypography } from '../../../components/common/FoxTypography'
import { FoxButton } from '../../../components/common/FoxButton'
import { AccountRequirementsModalProps } from '../../../containers/account/AccountRequirementsModal'
import { DomainCommonName } from '@foxtail-dev/datacontracts'
import { Domains } from '@foxtail-dev/datacontracts/dist/lib/schemas/Domains'

type AreYouSureYouWantToSignOutModalProps = {
    open: boolean
    onClose: (isConfirmed: boolean) => void
    domainName: DomainCommonName
}

export const AreYouSureYouWantToSignOutModal = ({ open, onClose, domainName }: AreYouSureYouWantToSignOutModalProps) => {
    return (
        <FoxModalDialog open={open} title={'Sign out?'} leftButtonKind={'close'} onClose={() => onClose(false)} closeOnBackdropClick>
            <Box sx={{ textAlign: 'center', width: '100%' }}>
                <FoxTypography variant='subtitle1' sx={{ marginBottom: '40px', marginTop: '40px' }}>
                    Are you sure you want to sign out of your {Domains[domainName].displayName} account? <br />
                    <br />
                    If you proceed any listings associated with this account will no longer by tracked by Foxtail
                </FoxTypography>

                <FoxButton
                    primary
                    onFoxClick={{ kind: 'button', onClick: async () => onClose(true) }}
                    text={'Yes, I want to sign out'}
                    sx={{ marginTop: '24px', width: '100%', justifyContent: 'center' }}
                />
            </Box>
        </FoxModalDialog>
    )
}
